import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function postcodeValidator(): ValidatorFn {
	const pattern =
		/^([Gg][Ii][Rr] 0[Aa]{2}|((([A-Za-z][0-9]{1,2})|([A-Za-z][A-HJ-Ya-hj-y][0-9]{1,2})|([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-HJ-Ya-hj-y][0-9]?[A-Za-z]))\s?[0-9][A-Za-z]{2}))$/;

	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;
		if (!value) {
			return null; // don't validate empty values here; use `Validators.required` separately
		}
		const isValid = pattern.test(value.trim());
		return isValid ? null : { invalidPostcode: true };
	};
}
